import React from 'react';

const ManageDrones = () => {
    return (
        <div>
            <h2>ManageProducts</h2>
        </div>
    );
};

export default ManageDrones;